import { FC } from 'react'
import { DateTimeWindow } from '../../formComponents'

import { ModalSectionProps } from '../utils'

export const DateTimeWindowSection: FC<ModalSectionProps> = ({
  formData,
  form,
  setFormData,
}) => {
  const maxDate = formData?.patternEnd

  const handleStartTimeChanged = (value?: string) => {
    setFormData?.((prev: any) => ({ ...prev, startTime: value }))
    form?.setFieldValue('startTime', value)
  }
  const handleEndTimeChanged = (value?: string) => {
    setFormData?.((prev: any) => ({ ...prev, endTime: value }))
    form?.setFieldValue('endTime', value)
  }

  return (
    <DateTimeWindow
      maxDate={maxDate}
      onEndTimeChanged={handleEndTimeChanged}
      onStartTimeChanged={handleStartTimeChanged}
    />
  )
}
